import api from '@/api';

export const getters = {
  featureGroups: state => {
    const featureGroups = state.featureGroups || [];

    return featureGroups.slice().sort((a, b) => a.name.localeCompare(b.name));
  },

  availableGroupsByOrg: state => {
    if (!state.availableGroupsByOrg) return [];

    const { availableGroupsByOrg } = state;
    return availableGroupsByOrg.slice().sort((a, b) => a.name.localeCompare(b.name));
  },

  featureGroupIds: state => {
    const featureGroups = state.featureGroups || [];

    return featureGroups.map(group => group.id);
  },

  getFeatureGroupById: state => groupId => {
    const featureGroups = state.featureGroups || [];

    return featureGroups.find(group => group.id === groupId);
  },

  canSetLearnerLevel: state => {
    return groupId => {
      if (!groupId || !Array.isArray(state.featureGroups)) {
        return false;
      }

      const featureGroup = state.featureGroups.find(group => group.id === groupId);

      return featureGroup ? featureGroup.enable_admins_to_set_learner_level : false;
    };
  },
};

export const mutations = {
  SET_FEATURE_GROUPS(state, featureGroups) {
    state.featureGroups = featureGroups;
  },
  SET_AVAILABLE_GROUPS_BY_ORG(state, availableGroupsByOrg) {
    state.availableGroupsByOrg = availableGroupsByOrg;
  },
};

export const actions = {
  FETCH_FEATURE_GROUPS: async ({ commit, dispatch, rootGetters }) => {
    dispatch('wait/start', 'fetching groups', { root: true });

    try {
      const featureGroups = await api.fetchFeatureGroups(rootGetters.organizationId);
      commit('SET_FEATURE_GROUPS', featureGroups);
    } finally {
      dispatch('wait/end', 'fetching groups', { root: true });
    }
  },

  FETCH_AVAILABLE_GROUPS_BY_ORG: async ({ commit, dispatch, rootGetters }) => {
    dispatch('wait/start', 'fetching available groups by org', { root: true });

    try {
      const availableGroupsByOrg = await api.fetchAvailableGroupsByOrg(rootGetters.organizationId);
      commit('SET_AVAILABLE_GROUPS_BY_ORG', availableGroupsByOrg);
    } finally {
      dispatch('wait/end', 'fetching available groups by org', { root: true });
    }
  },
};

const state = {
  featureGroups: [],
  availableGroupsByOrg: [],
};

export default {
  state,
  getters,
  actions,
  mutations,
};
